import { TFunction } from 'i18next';
import { GridEnrichedColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { DateCell } from './component';
import { ReceiptsRowViewModel } from '../../row/viewModel';
import { ReceiptsCellViewModel } from '../viewModel';

export class DateCellViewModel extends ReceiptsCellViewModel {
  constructor(row: ReceiptsRowViewModel) {
    super(row);
  }

  get t() {
    return this.row.translate;
  }

  get cellValue() {
    if (this.receipt.date) {
      return this.receipt.date.format();
    }
    return '-';
  }

  get value() {
    return this.cellValue;
  }

  static buildColDef(t: TFunction): GridEnrichedColDef {
    return {
      field: 'date',
      type: 'date',
      filterable: false,
      headerName: t('common:DATE'),
      minWidth: 74,
      flex: 1,
      renderCell: (params: GridRenderCellParams<DateCellViewModel>) => <DateCell {...params} />
    };
  }
}
